const baseURL = 'https://dashboard.amigos4trade.com/api'
export default baseURL